import { ReactNode } from 'react';
import { CodeType } from '../CodeType';
import { BuildCodeParams, CodeSample } from './CodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import React from 'react';
import CodeBlock from '../CodeBlock';

export default class FrontendRemixSample extends CodeSample {
  name = 'Remix';
  language = 'javascript';
  codeType = CodeType.FRONTEND;
  tabIcon = '';
  commentChar = undefined;

  buildCode({ environment, notification, user }: BuildCodeParams): ReactNode {
    const npmInstall = `npm install notificationapi-js-client-sdk
# Or if you are using Yarn: yarn add notificationapi-js-client-sdk`;

    const remixConfig = `serverDependenciesToBundle: ['notificationapi-js-client-sdk'];`;
    const styles = `import NotificationAPICSS from 'notificationapi-js-client-sdk/dist/styles.css';
      
export const links: LinksFunction = () => {
  return [
    { rel: 'stylesheet', href: NotificationAPICSS }
    // and the other links ...
  ];
};`;

    const code = `import NotificationAPIClient from 'notificationapi-js-client-sdk';
import { useEffect } from 'react';

export default function Index() {
  useEffect(() => {
    const notificationapi = new NotificationAPIClient({
      clientId: '${environment.clientId}',
      userId: '${user.id}'
    });

    notificationapi.showInApp({
      root: 'bell-container'
    });
  }, []);

  return (
    <main>
      <div id="bell-container"></div>
    </main>
  );
}`;

    return (
      <>
        <CodeBlock language="bash" code={npmInstall} />
        <Paragraph style={{ paddingTop: 10 }}>
          Add the following to your <Text code>remix.config.js</Text> file:
        </Paragraph>
        <CodeBlock language="bash" code={remixConfig} />
        <Paragraph>
          Add NotificationAPI styles to your root component:
        </Paragraph>
        <CodeBlock language="bash" code={styles} />
        <Paragraph>
          Create the following component and use it in your app:
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }
}
